/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavLink, Row, Col } from "react-bootstrap";

import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { useEnumApi } from 'contexts/EnumApiContext';
import { equipmentFaultStatusColors, getEquipmentCtgrImageNameByCodeOfDashboardSub, ROLE } from 'data/data';
import { getEquipmentAlertsByQuery, getEquipmentAlertsDiagnosisByQuery, getEquipmentsCategoriesById } from 'components/axios/equipmentAlertsAxios';
import { getStationsByQuery } from 'components/axios/stationAxios';
import { getEquipmentsById } from 'components/axios/equipmentAxios';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import MainCard from 'components/MainCard';
import ComponentStatusDiv from 'components/inner/ComponentStatusDiv';
import EquipmentPartListMonitoring from 'components/inner/EquipmentPartListMonitoring';
import FileViewerByFileUrl from 'components/FileViewerByFileUrl';
import EquipmentAlertListCard from 'components/inner/mainCard/EquipmentAlertListCard';
import FileDownloadIcon from 'components/FileDownloadIcon';
import PanoViewerLayer from 'components/layer/PanoViewerLayer';
import AlertRequestLayer from 'components/layer/AlertRequestLayer';
import MaintenanceByNoAlertRequestLayer from 'components/layer/MaintenanceByNoAlertRequestLayer';
import ComprehensiveReportLayer from 'components/layer/ComprehensiveReportLayer';
import EquipmentRemarkModifyLayer from 'components/layer/EquipmentRemarkModifyLayer';
import EquipmentImgFileModifyLayer from 'components/layer/EquipmentImgFileModifyLayer';
import { getDashboardCountGroupByFollowActionType } from 'components/axios/dashboardAxios';
import EquipmentStatusLayer from 'components/layer/EquipmentStatusLayer';
import EquipmentChecklistLayer from 'components/layer/EquipmentChecklistLayer';
import { getEquipmentPartsIncludingFaultsByEquipmentId } from 'components/axios/masterEquipmentPartsImageAxios';
import { useTheme } from 'components/ThemeContext';
import CCTVWebRTCLayer from 'components/layer/CCTVWebRTCLayer';
import CCTVButtons from 'components/CCTVButtons';

const EquipmentViewMonitoring = () => {
  const { getEnumValueByEnumNameAndCode, role } = useEnumApi();
  const { t } = useTranslation();
  const { mode } = useTheme();
  const {id} = useParams();
      
    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
      openModal(modals.alertModal, {
          onClose : () => {
          },
          message: alertMessage,
      });
    };

    const [info, setInfo] = useState(null);
    const [equipment, setEquipment] = useState(null);
    const [station, setStation] = useState(null);
    const [equipmentAlertInspections, setEquipmentAlertInspections] = useState();
    const [imgName, setImgName] = useState('noimage.gif');

    // const [equipmentAlertFollowActionType, setEquipmentAlertFollowActionType] = useState();
    const [alertCnt, setAlertCnt] = useState();
    const [referCnt, setReferCnt] = useState();
    const [equipmentAlertIng, setEquipmentAlertIng] = useState();
    // const [grade, setGrade] = useState();
    const [equipmentComponents, setEquipmentComponents] = useState([]);
    const [componentId, setComponentId] = useState(null);
    const [equipmentParts, setEquipmentParts] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!isLoading)
          equipmentInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[id, isLoading]);

    const equipmentInfo = () => {
        if (id) {
            Promise.all([
                getEquipmentsById(id).then((res)=>{
                    setInfo(res);
                    setEquipment(res);
                    // console.log(res)
                    if (res.equipmentCtgr.parent.parent.code === 'EV') {
                      if (res.latestEquipmentOp != null) {
                        setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(res.equipmentCtgr.parent.parent.code, res.latestEquipmentOp.opStatus, res.latestEquipmentOp.doorStatus, "view"));
                      } else {
                        setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(res.equipmentCtgr.parent.parent.code, null, null, "view"));
                      }
                    } else if (res.equipmentCtgr.parent.parent.code === 'ES') {
                      if (res.latestEquipmentOp != null) {
                        setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(res.equipmentCtgr.parent.parent.code, res.latestEquipmentOp.opStatus, null, "view"));
                      } else {
                        setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(res.equipmentCtgr.parent.parent.code, null, null, "view"));
                      }
                    } else {
                      setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(res.equipmentCtgr.parent.parent.code, res.latestEquipmentOp?.opStatus, null, "view"));
                    }
                    // setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(res.equipmentCtgr.parent.parent.code, null, null, "view"));
                    return res;
                }),
                getEquipmentAlertsByQuery({fllwActionType: "ne(O1_WAIT)", "equipment.id" : id, sort:"fllwActionType,desc"}).then((data)=>{
                    if (data && data._embedded) {
                        let list = data._embedded.equipmentAlerts;
                        setEquipmentAlertInspections(list);
                    }
                }),
                getEquipmentAlertsDiagnosisByQuery({"equipment.id" : id, status:"D", fllwActionType : 'O1_WAIT', sort:"latestAlertedAt,desc", size : 1}).then((data)=>{
                  if (data && data._embedded) {
                      let list = data._embedded.equipmentAlerts;
                      if (list) {
                        setEquipmentAlertIng(list[0]);
                        return list[0];
                      } else {
                        setEquipmentAlertIng(null);
                        return null;
                      }
                  }
                }),
                // // 설비 등급
                // getDiagnosisExecutionsEquipmentsLowestGradeById(id).then((data)=>{
                //   setGrade(data);
                // }),
                // 구성부목록
                getEquipmentsCategoriesById(id).then((data)=>{
                  // console.log(data)
                  if (data) {
                      setEquipmentComponents(data);
                      return data;
                  }
                  setEquipmentComponents(null);
                  return null;
                }),
                // getDashboardCountGroupByFollowActionType({"equipment.id" : id}).then((data)=>{
                //   return data;
                // }),
                getEquipmentPartsIncludingFaultsByEquipmentId(id).then((data)=>{
                  // console.log(data);
                  if (data && data.length > 0) {
                      if (data) {
                        const list = data.map((p)=>{
                          if(!p.hasFaultCodesOfAlertY && !p.hasFaultCodesOfAlertN) { // 정상
                            if (p.normalFileId == null && p.errorFileId != null) {
                              p.fileId = p.errorFileId;
                              p.fileContentType = p.errorFileContentType;
                            } else if (p.errorFileId == null) {
                              p.fileId = 0;
                            } else {
                              p.fileId = p.normalFileId;
                              p.fileContentType = p.normalFileContentType;
                            }
                          } else { // 에러
                            if (p.errorFileId == null && p.normalFileId != null) {
                              p.fileId = p.normalFileId;
                              p.fileContentType = p.normalFileContentType;
                            } else if (p.normalFileId == null) {
                              p.fileId = 0;
                            } else {
                              p.fileId = p.errorFileId;
                              p.fileContentType = p.errorFileContentType;
                            }
                          }
                          return p;
                        });
                        // console.log(list)
                        if (list.length<6) {
                          let partList = [...list];
                          for (let i=list.length;i<6;i++) {
                            partList.push({
                              "partName": "",
                              "partCode": "",
                              "partPosition": "",
                              "normalFileId": 0,
                              "errorFileId": 0,
                              "fileId":0,
                              "hasFaultCodesOfAlertY": false,
                              "hasFaultCodesOfAlertN": false
                            })
                          }
                          setEquipmentParts(partList);
                        } else {
                          setEquipmentParts(list);
                        }
                      } else {
                        let partList = [];
                        for (let i=0;i<6;i++) {
                          partList.push({
                            "partName": "",
                            "partCode": "",
                            "partPosition": "",
                            "normalFileId": 0,
                            "errorFileId": 0,
                            "fileId":0,
                            "hasFaultCodesOfAlertY": false,
                            "hasFaultCodesOfAlertN": false
                          })
                        }
                        setEquipmentParts(partList);
                      }
                  } else {
                    let partList = [];
                    for (let i=0;i<6;i++) {
                      partList.push({
                        "partName": "",
                        "partCode": "",
                        "partPosition": "",
                        "normalFileId": 0,
                        "errorFileId": 0,
                        "fileId":0,
                        "hasFaultCodesOfAlertY": false,
                        "hasFaultCodesOfAlertN": false
                      })
                    }
                    setEquipmentParts(partList);
                  }
                })
                // getEquipmentPartsWithSensorPositionByQuery({"equipment.id" : id}).then((data) => {
                //   // console.log(data)
                //     if (data && data.length > 0) {
                //         const list = data;
                //         // console.log(list)
                //         if (list) {
                //             if (list.length<6) {
                //               let partList = [...list];
                //               for (let i=list.length;i<6;i++) {
                //                 partList.push({"masterEquipmentPart":{"name" : ""},"position":""})
                //               }
                //               setEquipmentParts(partList);
                //             } else {
                //               setEquipmentParts(list);
                //             }
                //         } else {
                //           let partList = [];
                //           for (let i=0;i<6;i++) {
                //             partList.push({"masterEquipmentPart":{"name" : ""},"position":""})
                //           }
                //           setEquipmentParts(partList);
                //         }
                //     } else {
                //       let partList = [];
                //       for (let i=0;i<6;i++) {
                //         partList.push({"masterEquipmentPart":{"name" : ""},"position":""})
                //       }
                //       setEquipmentParts(partList);
                //     }
                    
                // })
            ]).then((res) => {
                if (res && res[0]) {
                    getStationsByQuery({id:res[0].station.id}).then((data)=>{
                        if (data && data._embedded) {
                            setStation(data._embedded.stations[0]);
                        }
                    });

                    setAlertCnt((res[0].status === 'O3_A') ? 1 : 0);
                    setReferCnt((res[0].status === 'O2_I') ? 1 : 0);

                    if (timerRef.current) {
                      clearTimeout(timerRef.current);
                      timerRef.current = null;
                    }
                    timerRef.current = setTimeout(repeatFunc, 5000);
                }
                if (res && res[2] === null) {
                    getEquipmentAlertsDiagnosisByQuery({"equipment.id" : id, status:"M", fllwActionType : 'O2_OBSERVE', sort:"latestAlertedAt,desc", "atentObserv.status":"V", size : 1}).then((data)=>{
                  //getEquipmentAlertsDiagnosisByQuery({"equipment.id" : id, status:"D", fllwActionType : 'O4_NORMAL', sort:"alertedAt,desc", size : 1}).then((data)=>{
                    if (data && data._embedded) {
                        let list = data._embedded.equipmentAlerts;
                        if (list)
                          setEquipmentAlertIng(list[0]);
                        else
                          setEquipmentAlertIng(null);
                    }
                  })
                }
                if (res && res[3] && res[3].length > 0) {
                  // const result = res[4].find(item=>item.sensorYn)
                  const result = res[3][0];
                  if (result)
                    equipmentPartsByComponentId(result.id);
                // } else if (res[0]?.equipmentCtgr?.parent?.parent?.code === 'EV' || res[0]?.equipmentCtgr?.parent?.parent?.code === 'ES') {
                } else if (res[0]?.latestEquipmentOp) {
                  equipmentPartsByComponentId(-1);
                }
                // console.log(res[5])
                // if (res && res[4] && res[4].length > 0) {
                //   // setEquipmentAlertFollowActionType(res[4])
                //   // setAlertCnt(res[4].reduce((acc, cur)=>{
                //   //   if (cur.name === 'O1_WAIT') {
                //   //       return acc + cur.count;
                //   //   }
                //   //   return acc
                //   // },0));
  
                //   // setReferCnt(res[4].reduce((acc, cur)=>{
                //   //   if (cur.name === 'O4_NORMAL') {
                //   //       return acc + cur.count;
                //   //   }
                //   //   return acc
                //   // },0));
                // }
                setIsLoading(true);
            })
        }
    }

    const timerRef = useRef(null);
    function repeatFunc() {
      try {
        if (id != null) {
          // console.log('func')
          Promise.all([
            getEquipmentsById(id).then((res)=>{
              let equip = {...res}
              // equip.latestEquipmentOp.opStatus = 'DOWN'
              // equip.status = 'O2_M'
              // equip.latestEquipmentOp.cntlrError = 'ER 23'
              setEquipment(equip);
              if (equip.equipmentCtgr.parent.parent.code === 'EV') {
                if (equip.latestEquipmentOp != null) {
                  setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(equip.equipmentCtgr.parent.parent.code, equip.latestEquipmentOp.opStatus, equip.latestEquipmentOp.doorStatus, "view"));
                } else {
                  setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(equip.equipmentCtgr.parent.parent.code, null, null, "view"));
                }
              } else if (equip.equipmentCtgr.parent.parent.code === 'ES') {
                if (equip.latestEquipmentOp != null) {
                  setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(equip.equipmentCtgr.parent.parent.code, equip.latestEquipmentOp.opStatus, null, "view"));
                } else {
                  setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(equip.equipmentCtgr.parent.parent.code, null, null, "view"));
                }
              } else {
                setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(equip.equipmentCtgr.parent.parent.code, equip.latestEquipmentOp?.opStatus, null, "view"));
              }
              // setImgName(getEquipmentCtgrImageNameByCodeOfDashboardSub(equip.equipmentCtgr.parent.parent.code, null, null, "view"));
            }),
            getEquipmentAlertsDiagnosisByQuery({"equipment.id" : id, status:"D", fllwActionType : 'O1_WAIT', sort:"latestAlertedAt,desc", size : 1}).then((data)=>{
              if (data && data._embedded) {
                let list = data._embedded.equipmentAlerts;
                if (list) {
                  setEquipmentAlertIng(list[0]);
                  return list[0];
                } else {
                  setEquipmentAlertIng(null);
                  return null;
                }
              }
            })
          ]).then((res) => {
            if (res && res[1] === null) {
              getEquipmentAlertsDiagnosisByQuery({"equipment.id" : id, status:"M", fllwActionType : 'O2_OBSERVE', sort:"latestAlertedAt,desc", "atentObserv.status":"V", size : 1}).then((data)=>{
              //getEquipmentAlertsDiagnosisByQuery({"equipment.id" : id, status:"D", fllwActionType : 'O4_NORMAL', sort:"alertedAt,desc", size : 1}).then((data)=>{
                if (data && data._embedded) {
                    let list = data._embedded.equipmentAlerts;
                    if (list)
                      setEquipmentAlertIng(list[0]);
                    else
                      setEquipmentAlertIng(null);
                }
              })
            }
          })
        }
      } catch (error) {
        console.error(error);
      } finally {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }
        timerRef.current = setTimeout(repeatFunc, 5000);
      }
    }

    useEffect(()=>{
      // console.log(isLoading);
        return () => {
          console.log('other page move')
          if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
          }
        }
      },[]);

    // 해당 구성부에 해당하는 자재목록
    const equipmentPartsByComponentId = (compId) => {
      // console.log(compId)
      // if (compId !== -1)
      setComponentId(compId);
    }

    // const [previewImage, setPreviewImage] = useState(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png");
    const [previewImage, setPreviewImage] = useState('');
    const [extension, setExtension] = useState("png");
    const [selectedImg, setSelectedImg] = useState([]);
    const [selectedBp, setSelectedBp] = useState("");
    // const [stream, setStream] = useState(null);
    const [selectedStream, setSelectedStream] = useState(null);

    useEffect(()=>{
        // if (info && info.imgFile) {
        //   setImageFromFile(info.imgFile, 1);
        // } else {
        //   setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
        // }
        if (info) {
          let copy = Array(info.imgFiles?.length).fill("");
          if (info && info.imgFiles && info.imgFiles.length > 0) {
            setImageFromFile(info.imgFiles[0], 1);
            copy[0] = " on";
          } else {
            setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
          }
          setSelectedImg(copy);
          setSelectedBp("");
        }
    },[info, isLoading, mode]);

    // const setCCTV = ( stream ) => {
    //   // console.log(stream)
    //   setStream(stream);
    //   // setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
    //   setSelectedImg([]);
    //   setSelectedBp("");
    // };

    const initDefaultImage = () => {
      setSelectedStream(null);
      setSelectedImg([]);
      setSelectedBp("");
    }

    const setImageFromFile = ( file , selectIdx ) => {
      initDefaultImage();
      setPreviewImage(process.env.REACT_APP_API_URL+"/api/download/"+file?.id);
      setExtension("png");
      // console.log(selectIdx)
      if (selectIdx <= info.imgFiles.length) {
        let copy = Array(info.imgFiles?.length).fill("");
        copy[selectIdx-1] = " on";
        setSelectedImg(copy);
        setSelectedBp("");
      } else {
        setSelectedImg([]);
        setSelectedBp(" on");
      }
    };

    const setDefaultImageFromFile = ( selectIdx ) => {
      initDefaultImage();
      setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
      setExtension("png");
      if (selectIdx <= info.imgFiles.length) {
        let copy = Array(info.imgFiles?.length).fill("");
        copy[selectIdx-1] = " on";
        setSelectedImg(copy);
        setSelectedBp("");
      } else {
        setSelectedImg([]);
        setSelectedBp(" on");
      }
    };

    const playMovie = (diagnosisId) => {
      setPreviewImage(process.env.REACT_APP_API_URL+"/api/download/:direct?fileGroup=DCV&id="+diagnosisId);
      setExtension("mp4");
    }

    if (station && info) {
        let titleLinkUrl = "/equipment";
        return (
    <div className="sub_container">
        <div className="moni_tit_box" style={{display:"flex", alignItems:"center", flexWrap:"wrap"}}>
          <h5 style={{color:"#fff", borderRadius:"0"}}>
          {/* <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway.png`} alt='' /></span>&nbsp;
          <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}`}>
          {getEnumValueByEnumNameAndCode("SubwayLine", station.workingPart.subwayLine) && getEnumValueByEnumNameAndCode("SubwayLine", station.workingPart.subwayLine)[0].title} 
          </Link>
          <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}`}>
          &gt; {station.workingPart.name} 
          </Link>
          <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}`}>
          &gt; ({station.code}){station.name}
          </Link>
          <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${info.equipmentCtgr.parent.parent.id}`}>
          &gt; {info.equipmentCtgr && info.equipmentCtgr.parent && info.equipmentCtgr.parent.parent && (info.equipmentCtgr.parent.parent.name || '')} 
          </Link>
          <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${info.equipmentCtgr.parent.parent.id}&searchlevel2=${info.equipmentCtgr.parent.id}`}>
          &gt; {info.equipmentCtgr && info.equipmentCtgr.parent && (info.equipmentCtgr.parent.name || '')} 
          </Link>
          <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${info.equipmentCtgr.parent.parent.id}&searchlevel2=${info.equipmentCtgr.parent.id}&searchlevel3=${info.equipmentCtgr.id}`}>
          &gt; {info.equipmentCtgr && (info.equipmentCtgr.name || '')}
          </Link>
          <Link to={`${titleLinkUrl}?searchField=name&searchKeyword=${info.name}&searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${info.equipmentCtgr.parent.parent.id}&searchlevel2=${info.equipmentCtgr.parent.id}&searchlevel3=${info.equipmentCtgr.id}`}>
          &gt; {info.name || ''}
          </Link> */}
          {info.name}({info.equipmentNo})
          </h5>
          <div>
          {role !== ROLE.MO.code &&
          <><AlertRequestLayer id={info.id} setIsLoading={setIsLoading} />
          </>}
          {/* &nbsp;<CCTVWebRTCLayer stream="stream1" /> */}
          &nbsp;<EquipmentChecklistLayer info={info} />
          &nbsp;<ComprehensiveReportLayer info={info} station={station} previewImage={previewImage} />
          </div>
        </div>
        
        <Row>
          <Col sm={5} className="sub_left">
            {(previewImage || extension || selectedStream) && <FileViewerByFileUrl fileUrl={previewImage} extension={extension} selectedStream={selectedStream} />}
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:"10px", width:"100%"}}>
              <div className="vr_btn_box">
                <div>
                  {/* {info?.imgFile ?
                  <div className="vr_btn">
                      <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedImg} color="primary" onClick={()=>setImageFromFile(info.imgFile, 1)}>
                        <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/construction.png`} alt='' /></span>&nbsp;{t('message.common.btn.equipment')}
                      </Button>
                  </div>
                  :
                  <div className="vr_btn">
                      <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedImg} color="primary" onClick={()=>setDefaultImageFromFile(1)}>
                        <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/construction.png`} alt='' /></span>&nbsp;{t('message.common.btn.equipment')}
                      </Button>
                  </div>
                  } */}
                  {info?.imgFiles && info.imgFiles.length > 0 ?
                  <div className="vr_btn">
                    {info.imgFiles.map((img, i)=>{
                      return (
                      <Button key={i} variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedImg[i]} color="primary" onClick={()=>setImageFromFile(img, i+1)}>
                        <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/construction.png`} alt='' /></span>&nbsp;{t('message.common.btn.equipment')}{i+1}
                      </Button>
                      )
                    })}
                  </div>
                  :
                  <div className="vr_btn">
                      <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} color="primary" onClick={()=>setDefaultImageFromFile(1)}>
                        <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/construction.png`} alt='' /></span>&nbsp;{t('message.common.btn.equipment')}
                      </Button>
                  </div>
                  }
                  {info && info.bpFile &&
                  <div className="vr_btn">
                      <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedBp} color="primary" onClick={()=>setImageFromFile(info.bpFile, info.imgFiles.length+1)}>
                        <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/history_edu.png`} alt='' /></span>&nbsp;{t('message.common.btn.floor.plan')}
                      </Button>
                  </div>
                  }
                </div>

                <div>
                  {info && info.vrFiles && info.vrFiles.map(function(item, i) {
                      return (
                  <div key={i}><PanoViewerLayer info={info} idx={i+1} /></div>
                      )
                  })}
                </div>
              </div>
              <div style={{display:"flex"}}>
                <CCTVButtons selectedStream={selectedStream} onSelect={setSelectedStream} initDefaultImage={initDefaultImage} />
                {/* <div className="vr_btn">
                    <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedBp} color="primary" onClick={()=>setCCTV("stream1")}>
                      &nbsp;CCTV stream1 Viewer
                    </Button>
                    <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedBp} color="primary" onClick={()=>setCCTV("stream2")}>
                      &nbsp;CCTV stream2 Viewer
                    </Button>
                </div> */}
                {/* <CCTVWebRTCLayer stream='stream1'/><CCTVWebRTCLayer stream='stream2'/> */}
                <EquipmentImgFileModifyLayer equipmentId={info && info.id} setIsLoading={setIsLoading} />
              </div>
            </div>

            <div>
              <div>
                {info && info.files && info.files.map(function(item, i) {
                    return (
                <div key={i} style={{width:"100%"}}><FileDownloadIcon file={item} viewFileName={true} iconSize="small" /></div>
                    )
                })}
              </div>
            </div>

            <div className='alert_phrase' style={{marginTop: "20px"}}>
              <MainCard className="center_table" content={false}>
                <TableContainer>
                  <Table sx={{ minWidth: 500 }} aria-label="simple table">
                    <TableBody>
                      {/* {station && 
                      <TableRow>
                        <TableCell className="th" style={{width:"15%"}} align="center">{t('message.common.subtitle.station.mngrNm')}</TableCell>
                        <TableCell align="center" style={{width:"20%"}}>{station.mngrNm}</TableCell>
                        <TableCell className="th" style={{width:"15%"}} align="center">{t('message.common.subtitle.station.workingPart.name')}</TableCell>
                        <TableCell align="center" style={{width:"20%"}}>{station.workingPart.name}</TableCell>
                        <TableCell className="th" style={{width:"15%"}} align="center">{t('message.common.subtitle.station.jobTitle')}</TableCell>
                        <TableCell align="center" style={{width:"15%"}}>{station.jobTitle}</TableCell>
                      </TableRow>
                      }
                      {station && 
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.station.assignedYmd')}</TableCell>
                        <TableCell align="center">{station.assignedYmd}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.station.eduCompletedYmd')}</TableCell>
                        <TableCell align="center" colSpan={3}>{station.eduCompletedYmd}</TableCell>
                      </TableRow>
                      } */}
                      {info &&
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                        <TableCell align="center">{info.equipmentCtgr.parent.name}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                        <TableCell align="center" colSpan={3}>{info.equipmentCtgr.name}</TableCell>
                      </TableRow>
                      }
                      {info &&
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.equipment.number')}</TableCell>
                        <TableCell align="center">{info.equipmentNo}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.mfCpnyNm')}</TableCell>
                        <TableCell align="center" colSpan={2}>{info.mfCpnyNm}</TableCell>
                        <TableCell align="center"><EquipmentStatusLayer info={info} /></TableCell>
                      </TableRow>
                      }
                      {info &&
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.madeYmd')}</TableCell>
                        <TableCell align="center">{info.madeYmd}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                        <TableCell align="center">{info.location}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                        <TableCell align="center">
                          <div className={info.opStatus && info.opStatus==='O' ? "condition6" : "condition1"} style={{margin:"unset", width:"auto", display:"inline-block", padding:"1px 15px"}}>
                          {info.opStatus && getEnumValueByEnumNameAndCode("EquipmentOpStatus", info.opStatus) && getEnumValueByEnumNameAndCode("EquipmentOpStatus", info.opStatus)[0].title}
                          </div>
                        </TableCell>
                      </TableRow>
                      }
                      {info &&
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                        <TableCell align="center" colSpan={5}>
                          <div  style={{display:"flex"}}>
                            <div style={{whiteSpace:"pre-line", textAlign:"left"}}>
                              {info.remark}
                            </div>
                            <EquipmentRemarkModifyLayer equipmentId={info.id} setIsLoading={setIsLoading} />
                          </div>
                        </TableCell>
                      </TableRow>
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </MainCard>
            </div>

            <EquipmentAlertListCard equipmentId={info.id} equipmentNo={info.equipmentNo} setIsLoading={setIsLoading} />
            
            <div className="btn_right" style={{marginTop:"10px", justifyContent:'space-between'}}>
                <Link to={'/equipment'+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link>
                {role !== ROLE.MO.code &&
                <>&nbsp;&nbsp;<MaintenanceByNoAlertRequestLayer equipmentId={info.id} setIsLoading={setIsLoading} /></>
                }
            </div>
          </Col>

          <Col sm={7} className="sub_right">
            <div className='equip_alert_view'>
              {/* equip_fan_stop, equip_fan, equip_pump_stop, equip_pump */}
              {/* <div className='equip_view_message'>
                <img src={`${process.env.PUBLIC_URL}/img/view/equip_pump.gif`} />
                <p className='error'>Error : CODE</p>
              </div> */}

              <div className='elevator_motion equip_view_message equip_view_nomessage'>
                <div className='equip_view_img'>
                  {/* {(equipment.status === 'O2_M' 
                  || alertCnt > 0 || referCnt > 0) && */}
                  <div className="alert_box">
                    {alertCnt > 0 ? <div className="red_c"><span>!</span></div> :
                    (
                    // (equipment.status === 'O2_M') ? <div className="orange_c"><span>!</span></div> :
                    (referCnt > 0 ? <div className="yellow_c"><span>!</span></div> : '')
                    )}
                  </div>
                  {/* } */}

                  {equipment.equipmentCtgr.parent.parent.code === 'EV' && <p className='floor'><span className='font_blue'>{equipment.latestEquipmentOp?.opMode?.integratedName || ''}</span><span>{equipment.latestEquipmentOp?.currentFloor || '-'}</span><span className={`${equipment.latestEquipmentOp.opStatus === 'DOWN' ? 'downarrow':''} font_green`}>{equipment.latestEquipmentOp.opStatus === 'UP' ?'▲':equipment.latestEquipmentOp.opStatus === 'DOWN' ? '▼':''}</span></p>}
                  {equipment.equipmentCtgr.parent.parent.code === 'ES' && <p className='floor'><span className='font_blue'>{equipment.latestEquipmentOp?.opMode?.integratedName || ''}</span><span>-</span><span className={`${equipment.latestEquipmentOp.opStatus === 'DOWN' ? 'downarrow':''} font_green`}>{equipment.latestEquipmentOp.opStatus === 'UP' ?'▲':equipment.latestEquipmentOp.opStatus === 'DOWN' ? '▼':''}</span></p>}
                  {imgName && <img src={`${process.env.PUBLIC_URL}/img/view/${imgName}`} alt='' />}
                  {/* {(equipment.equipmentCtgr.parent.parent.code === 'EV' || equipment.equipmentCtgr.parent.parent.code === 'ES') && <p className={`error${equipment?.latestEquipmentOp?.controlPanelCode?.usrDfnCd?.toLowerCase() === 'none' ? ' font_green': ''}`}>Error : {equipment?.latestEquipmentOp?.controlPanelCode?.usrDfnCd}</p>} */}
                  {(equipment.equipmentCtgr.parent.parent.code === 'EV' || equipment.equipmentCtgr.parent.parent.code === 'ES') && 
                    <p className={`error${equipment?.latestEquipmentOp?.controlPanelCode?.alertYn === 'N' ? ' font_green': ''}`}>
                      {equipment?.latestEquipmentOp?.controlPanelCode?.alertYn === 'N' ? t('message.common.normal') : equipment?.latestEquipmentOp?.controlPanelCode?.usrDfnCd}
                    </p>
                  }
                </div>

                {/* 부품이미지지 */}
                <div className='equip_part_img'>
                  {/* <img src={`${process.env.PUBLIC_URL}/img/view/part/escalator/chain_up.gif`} alt='' />
                  <img src={`${process.env.PUBLIC_URL}/img/view/part/escalator/foothold_down.gif`} alt='' />
                  <img src={`${process.env.PUBLIC_URL}/img/view/part/escalator/motor_down.gif`} alt='' />
                  <img src={`${process.env.PUBLIC_URL}/img/view/part/escalator/rotating body_down.gif`} alt='' />
                  <img src={`${process.env.PUBLIC_URL}/img/view/part/escalator/chain_up.gif`} alt='' /> */}
                  {equipmentParts && equipmentParts.map((part, pIdx)=>{
                    // console.log(part)
                    if (pIdx < 6) {
                      return (
                  <div key={pIdx} style={{marginBottom:"5px" , width:"50%", textAlign:"center"}}>
                    <p>{part.partName}&nbsp;{part.partPosition}</p>
                    {part.partName && part.fileId > 0 ?
                    <FileViewerByFileUrl fileUrl={`${process.env.REACT_APP_API_URL}/api/download/${part.fileId}`} extension={part.fileContentType?.split('/')[1] || '.png'} status={equipment.latestEquipmentOp?.opStatus} muted={true} />
                    // <img src={`${process.env.PUBLIC_URL}/img/view/sample.gif`} alt='' />
                    :<FileViewerByFileUrl fileUrl={`${process.env.PUBLIC_URL}/img/view/${mode === 'white' ? "sample1.png" : "sample.png"}`} extension={'.png'} muted={true} />
                    }
                  </div>
                      )
                    }
                  })}
{/*                   
                  <div style={{width:"190px"}}>
                    <p>电动机1X1</p>
                    <FileViewerByFileUrl fileUrl={`${process.env.PUBLIC_URL}/img/1.mp4`} extension={'.mp4'} muted={true} />
                  </div>
                  <div style={{width:"196px"}}>
                    <p>电动机1X1</p>
                    <FileViewerByFileUrl fileUrl={`${process.env.PUBLIC_URL}/img/3.mp4`} extension={'.mp4'} muted={true} />
                  </div>
                  <div style={{width:"196px"}}>
                    <p>电动机1X1</p>
                    <FileViewerByFileUrl fileUrl={`${process.env.PUBLIC_URL}/img/4.mp4`} extension={'.mp4'} muted={true} />
                  </div>
                  <div style={{width:"196px"}}>
                    <p>电动机1X1</p>
                    <FileViewerByFileUrl fileUrl={`${process.env.PUBLIC_URL}/img/5.mp4`} extension={'.mp4'} muted={true} />
                  </div>
                  <div style={{width:"196px"}}>
                    <p>1111</p>
                    <FileViewerByFileUrl fileUrl={`${process.env.PUBLIC_URL}/img/view/sample.png`} extension={'.png'} />
                  </div>
                  <div>
                    <p>222</p>
                    <img src={`${process.env.PUBLIC_URL}/img/view/sample.png`} alt='' />
                  </div> */}
                </div>
              </div>
            </div>
            <br/>
            {equipmentAlertIng && 
            <div className='alert_phrase'>
              <div style={{display: "flex", alignItems: "center", marginBottom: "7px"}}>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                <p style={{fontSize: "18px", fontWeight: "bold"}} className={equipmentAlertIng.fllwActionType}>{equipmentAlertIng.fllwActionType === 'O1_WAIT' ? t('message.common.title.alarm') : t('message.common.title.reference')}</p>
              </div>
              <p className='alert_phrase_cont'>
              {equipmentAlertIng.alertDtl || ''}{equipmentAlertIng.alertDtl && <br/>}
              {
                  equipmentAlertIng.equipmentPartFaultCodes && equipmentAlertIng.equipmentPartFaultCodes.length > 0 ?
                  equipmentAlertIng.equipmentPartFaultCodes.map(function(codes, idx) {
                    return (
                <div key={idx}>
					          {codes.equipmentPart?.masterEquipmentPart?.name}[{codes.equipmentPart?.position}]-
                    {codes.diagnosisCode?.subCategoryNm}({codes.diagnosisCode?.categoryNm})
                    &nbsp;<span className="icon_png" style={{verticalAlign:"middle", cursor:"pointer"}} onClick={()=>{playMovie(codes.diagnosisCode?.code)}}>
                      <img src={`${process.env.PUBLIC_URL}/img/icon/emergency_recording.png`} alt='' />
                    </span><br />
                </div> 
                    )
                    })
                    : ""
              }
              </p>
            </div>
            }

            <div className='alert_phrase'>
              <div style={{display: "flex", alignItems: "center", marginBottom:"5px"}}>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                <Chip label={t('message.common.title.equipment.status')} color="success"/>
              </div>
              <MainCard content={false} className="mobile_top">
                <TableContainer>
                  <Table sx={{ minWidth: 500 }} aria-label="simple table">
                    <TableBody>
                      <TableRow className='statustab_bg'>
                        <TableCell style={{textAlign:"left"}}>
                          <ComponentStatusDiv equipment={info} equipmentComponents={equipmentComponents} componentId={componentId} equipmentPartsByComponentId={equipmentPartsByComponentId} />
                        </TableCell>
                        <TableCell align="center" style={{fontSize:"25px"}}>
                          {/* <span className={getDiagnosisGradeColor(grade)}>{t('message.common.subtitle.defect')} : {grade || '-'}</span> */}
                          <span className={equipmentFaultStatusColors.find(data => data.code === info.status)?.color}>{t('message.common.subtitle.defect')} : {getEnumValueByEnumNameAndCode('EquipmentFaultStatus',info.status)[0]?.title || '-'}</span>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </MainCard>
            
              {componentId && <EquipmentPartListMonitoring equipment={info} componentId={componentId} equipmentAlertIng={equipmentAlertIng} />}
            </div>

          </Col>
        </Row>
    </div>
        )
    }
}

export default EquipmentViewMonitoring;